import { render, staticRenderFns } from "./IdeiaView.vue?vue&type=template&id=24663b81&scoped=true&"
import script from "./IdeiaView.vue?vue&type=script&lang=js&"
export * from "./IdeiaView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24663b81",
  null
  
)

export default component.exports